import React from 'react';
import {styled} from '@mui/material/styles';
import PropTypes from 'prop-types';
import logo from '../../../assets/logo-full-pos.svg';
import {FormattedMessage as Intl} from 'react-intl';

const PREFIX = 'AuthHeader';

const classes = {
  header: `${PREFIX}-header`,
  brand: `${PREFIX}-brand`,
  title: `${PREFIX}-title`,
  logo: `${PREFIX}-logo`,
};

const Root = styled('div')(() => ({
  [`&.${classes.header}`]: {
    display: 'flex',
    flexDirection: 'column',
    color: '#58595b',
    fontSize: '1.0rem',
    alignItems: 'center',
  },

  [`& .${classes.brand}`]: {
    display: 'flex',
    flexDirection: 'row',
    color: '#ffffff',
    fontSize: '1rem',
    alignItems: 'center',
    fontFamily: 'Barlow, sans-serif',
  },

  [`& .${classes.title}`]: {
    fontSize: '1.2rem',
  },

  [`& .${classes.logo}`]: {
    height: '4rem',
  },
}));

const AuthHeader = ({title}) => (
  <Root className={classes.header}>
    <div className={classes.brand}>
      <img src={logo} alt={title} className={classes.logo}/>
    </div>
    <h2 className={classes.title}><Intl id={title}/></h2>
  </Root>
);
AuthHeader.propTypes = {
  title: PropTypes.string.isRequired,
};
export default (AuthHeader);
